<template>
  <v-container fluid>
    <div v-if="authState !== 'signedin'">You are signed out.</div>
    <amplify-authenticator>
      <div v-if="authState === 'signedin' && user">
        <v-card>
          <v-form @submit.prevent="addLoanType" ref="form" v-model="valid">
            <v-row no-gutters>
              <v-card-title class="text-h5"> Loan Types </v-card-title>
              <v-card-actions>
                <v-btn
                  depressed
                  min-width="0"
                  :color="!showAddLoanType ? 'green' : 'red'"
                  :dark="!loading"
                  :disabled="loading"
                  :loading="loading"
                  @click="
                    !showAddLoanType
                      ? showAddLoanTypeFunction()
                      : clearLoanType()
                  "
                >
                  <v-icon>{{
                    !showAddLoanType ? "mdi-plus" : "mdi-delete"
                  }}</v-icon>
                </v-btn>
              </v-card-actions>
            </v-row>
            <div class="d-flex" v-if="showAddLoanType && windowWidth > 2350">
              <v-text-field
                label="Loan Amount"
                v-model="newModelLoanType.randValue"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Term"
                v-model="newModelLoanType.periodNumber"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Period"
                v-model="newModelLoanType.period"
                type="string"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Initial fee once off"
                v-model="newModelLoanType.initialFee"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Interest"
                v-model="newModelLoanType.interest"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Total Interest"
                v-model="newModelLoanType.totalInterest"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Debit order"
                v-model="newModelLoanType.debitOrder"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Credit type"
                v-model="newModelLoanType.creditType"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Credit life per month"
                v-model="newModelLoanType.creditLifeFee"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Service fee per month"
                v-model="newModelLoanType.serviceCharge"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Payment per month"
                v-model="newModelLoanType.payment"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <v-text-field
                label="Total Payment"
                v-model="newModelLoanType.totalPayment"
                type="number"
                :rules="requiredRule"
                outlined
                dense
                class="mr-5"
              ></v-text-field>
              <div class="d-flex" style="width: fit-content">
                <v-text-field
                  label="Admin Fee"
                  v-model="newModelLoanType.adminFee"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="For office use"
                  v-model="newModelLoanType.code"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
              </div>
            </div>
            <div
              v-else-if="
                showAddLoanType && windowWidth <= 2350 && windowWidth > 1200
              "
            >
              <div class="d-flex">
                <v-text-field
                  label="Loan Amount"
                  v-model="newModelLoanType.randValue"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Term"
                  v-model="newModelLoanType.periodNumber"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Period"
                  v-model="newModelLoanType.period"
                  type="string"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Initial fee once off"
                  v-model="newModelLoanType.initialFee"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Interest"
                  v-model="newModelLoanType.interest"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Total Interest"
                  v-model="newModelLoanType.totalInterest"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field
                  label="Debit order"
                  v-model="newModelLoanType.debitOrder"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Credit type"
                  v-model="newModelLoanType.creditType"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Credit life per month"
                  v-model="newModelLoanType.creditLifeFee"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Service fee per month"
                  v-model="newModelLoanType.serviceCharge"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Payment per month"
                  v-model="newModelLoanType.payment"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Total Payment"
                  v-model="newModelLoanType.totalPayment"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
              </div>
              <div class="d-flex" style="width: fit-content">
                <v-text-field
                  label="Admin Fee"
                  v-model="newModelLoanType.adminFee"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="For office use"
                  v-model="newModelLoanType.code"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
              </div>
            </div>
            <div v-else-if="showAddLoanType && windowWidth <= 1200">
              <div class="d-flex">
                <v-text-field
                  label="Loan Amount"
                  v-model="newModelLoanType.randValue"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Term"
                  v-model="newModelLoanType.periodNumber"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Period"
                  v-model="newModelLoanType.period"
                  type="string"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Initial fee once off"
                  v-model="newModelLoanType.initialFee"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field
                  label="Interest"
                  v-model="newModelLoanType.interest"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Total Interest"
                  v-model="newModelLoanType.totalInterest"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Debit order"
                  v-model="newModelLoanType.debitOrder"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Credit type"
                  v-model="newModelLoanType.creditType"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field
                  label="Credit life per month"
                  v-model="newModelLoanType.creditLifeFee"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Service fee per month"
                  v-model="newModelLoanType.serviceCharge"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Payment per month"
                  v-model="newModelLoanType.payment"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="Total Payment"
                  v-model="newModelLoanType.totalPayment"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
              </div>
              <div class="d-flex" style="width: fit-content">
                <v-text-field
                  label="Admin Fee"
                  v-model="newModelLoanType.adminFee"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
                <v-text-field
                  label="For office use"
                  v-model="newModelLoanType.code"
                  type="number"
                  :rules="requiredRule"
                  outlined
                  dense
                  class="mr-5"
                ></v-text-field>
              </div>
            </div>
            <v-row no-gutters v-if="showAddLoanType && errorMessage">
              <span class="red--text caption">{{ errorMessage }}</span>
            </v-row>
            <v-row no-gutters v-if="showAddLoanType">
              <v-btn
                depressed
                min-width="0"
                color="green"
                :dark="valid && !creatingLoanType"
                :disabled="!valid || creatingLoanType"
                :loading="creatingLoanType"
                @click="addLoanType()"
                >Add Loan Type</v-btn
              >
            </v-row>
          </v-form>
          <v-data-table
            :headers="loanTypeHeaders"
            :items="loanTypes"
            item-key="id"
            :loading="loading"
            sort-by="code"
            loading-text="Loading Loan Types..."
            :search="search"
            ><template v-slot:[`item.randValue`]="{ item }">
              {{ "R" + item.randValue.toFixed(2) }}
            </template>
            <template v-slot:[`item.adminFee`]="{ item }">
              {{ "R" + item.adminFee.toFixed(2) }}
            </template>
            <template v-slot:[`item.totalInterest`]="{ item }">
              {{ "R" + item.totalInterest.toFixed(2) }}
            </template>
            <template v-slot:[`item.creditLifeFee`]="{ item }">
              {{ "R" + item.creditLifeFee.toFixed(2) }}
            </template>
            <template v-slot:[`item.serviceCharge`]="{ item }">
              {{ "R" + item.serviceCharge.toFixed(2) }}
            </template>
            <template v-slot:[`item.payment`]="{ item }">
              {{ "R" + item.payment.toFixed(2) }}
            </template>
            <template v-slot:[`item.totalPayment`]="{ item }">
              {{ "R" + item.totalPayment.toFixed(2) }}
            </template>
            <template v-slot:top>
              <v-toolbar flat>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="deleteLoanType(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
          <v-card-actions>
            <span class="red--text caption">{{ error }}</span>
          </v-card-actions>
        </v-card>
        <!-- <v-snackbar bottom :value="true" :timeout="-1" color="primary">
          Beep.
          <template v-slot:action="{ attrs }">
            <v-btn
              v-bind="attrs"
              depressed
              color="green"
              @click="UpdateLoanTypes()"
              >Upload Data</v-btn
            >
          </template>
        </v-snackbar> -->
      </div>
    </amplify-authenticator>
  </v-container>
</template>

<script>
import { layout } from "@/mixins";
import { onAuthUIStateChange } from "@aws-amplify/ui-components";
import { DataStore } from "@aws-amplify/datastore";
import { LoanType } from "@/models";
import _ from "lodash";
// import ViewSingleCompany from "@/components/admin/ViewSingleCompany";
// import AddSingleCompany from "@/components/admin/AddSingleCompany";

export default {
  mixins: [layout],
  name: "AdminLoanTypes",
  components: {
    // ViewSingleCompany,
    // AddSingleCompany,
  },
  data: () => ({
    theme: "admin",
    valid: false,
    showAddLoanType: false,
    errorMessage: "",
    loading: true,
    error: null,
    creatingLoanType: false,
    newModelLoanType: {
      randValue: null,
      periodNumber: null,
      period: null,
      adminFee: null,
      totalInterest: null,
      interest: null,
      debitOrder: null,
      creditType: null,
      creditLifeFee: null,
      serviceCharge: null,
      payment: null,
      totalPayment: null,
      code: null,
    },
    subscription: null,
    loanTypes: [],
    immutableLoanTypes: [],
    user: undefined,
    authState: undefined,
    unsubscribeAuth: undefined,
    search: "",
    requiredRule: [(v) => !!v || "Required"],
    loanTypeHeaders: [
      {
        text: "Loan Amount",
        value: "randValue",
        class: "grey lighten-2",
      },
      {
        text: "Term",
        value: "periodNumber",
      },
      {
        text: "Period",
        value: "period",
        class: "grey lighten-2",
      },
      {
        text: "Initial fee once off",
        value: "adminFee",
      },
      {
        text: "Interest",
        value: "totalInterest",
        class: "grey lighten-2",
      },
      {
        text: "Debit Order",
        value: "debitOrder",
      },
      {
        text: "Credit Type",
        value: "creditType",
        class: "grey lighten-2",
      },
      {
        text: "Credit life per month",
        value: "creditLifeFee",
      },
      {
        text: "Service fee per month",
        value: "serviceCharge",
        class: "grey lighten-2",
      },
      {
        text: "Payment per month",
        value: "payment",
      },
      {
        text: "Total Payment",
        value: "totalPayment",
        class: "grey lighten-2",
      },
      {
        text: "For office use",
        value: "code",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "grey lighten-2",
      },
    ],
  }),

  mounted() {
    this.queryLoanTypes();
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      this.user = authData;
      this.queryLoanTypes();
    });
  },
  methods: {
    async queryLoanTypes() {
      try {
        this.subscription = DataStore.observeQuery(LoanType).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (
              isSynced &&
              items.length > 0 &&
              this.immutableLoanTypes !== items
            ) {
              this.loanTypes = _.cloneDeep(items);
              this.immutableLoanTypes = items;
              this.loading = false;
              // this.subscription.unsubscribe();
            }
          }
        );
      } catch (err) {
        console.log(err);
      }
    },

    async UpdateLoanTypes() {
      try {
        let count = 0;

        for (let i in this.immutableLoanTypes) {
          // IF statement for prod -- if (this.immutableLoanTypes[i].createdAt.startsWith("2022-09-02"))
          if (
            this.immutableLoanTypes[i].createdAt.startsWith("2022-05-26") &&
            !this.immutableLoanTypes[i].updatedAt.startsWith("2023-08-31")
          ) {
            await DataStore.save(
              LoanType.copyOf(this.immutableLoanTypes[i], (updateLoanType) => {
                updateLoanType.serviceCharge = parseFloat(
                  (
                    this.immutableLoanTypes[i].serviceCharge /
                    this.immutableLoanTypes[i].periodNumber
                  ).toFixed(2)
                );
                updateLoanType.creditLifeFee = parseFloat(
                  (
                    this.immutableLoanTypes[i].creditLifeFee /
                    this.immutableLoanTypes[i].periodNumber
                  ).toFixed(2)
                );
              })
            );
            console.log(++count);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    // async UploadMassData() {
    //   const csvData = `loanType;randValue;periodNumber;period;payment;interest;totalPayment;totalInterest;adminFee;serviceCharge;creditLifeFee;debitOrder;creditType
    // string;string;string;string;string;string;string;string;string;string;string;string;string
    // `;
    //   const parseCsv = (csv) => {
    //     let lines = csv.split("\n");
    //     const header = lines.shift().split(";");
    //     lines.shift();
    //     return lines.map((line) => {
    //       const bits = line.split(";");
    //       let obj = {};
    //       header.forEach((h, i) => {
    //         obj[h] = bits[i].trim().replace(",", ".");
    //       });
    //       return obj;
    //     });
    //   };
    //   try {
    //     const data = parseCsv(csvData);
    //     var count = 0;
    //     for (let d in data) {
    //       const modelToUpdate = _.find(this.immutableLoanTypes, {
    //         code: parseInt(data[d].loanType),
    //       });
    //       if (modelToUpdate) {
    //         await DataStore.save(
    //           LoanType.copyOf(modelToUpdate, (updateLoanType) => {
    //             updateLoanType.randValue = parseFloat(data[d].randValue);
    //             updateLoanType.periodNumber = parseInt(data[d].periodNumber);
    //             updateLoanType.period = data[d].period;
    //             updateLoanType.payment = parseFloat(data[d].payment);
    //             updateLoanType.interest = parseFloat(data[d].interest);
    //             updateLoanType.totalPayment = parseFloat(data[d].totalPayment);
    //             updateLoanType.totalInterest = parseFloat(
    //               data[d].totalInterest
    //             );
    //             updateLoanType.adminFee = parseFloat(data[d].adminFee);
    //             updateLoanType.serviceCharge = parseFloat(
    //               data[d].serviceCharge
    //             );
    //             updateLoanType.creditLifeFee = parseFloat(
    //               data[d].creditLifeFee
    //             );
    //             updateLoanType.debitOrder = parseFloat(data[d].debitOrder);
    //             updateLoanType.creditType = parseInt(data[d].creditType);
    //           })
    //         );
    //       }
    //       // await DataStore.save(
    //       //   new LoanType({
    //       //     code: parseInt(data[d].loanType),
    //       //     randValue: parseFloat(data[d].randValue),
    //       //     periodNumber: parseInt(data[d].periodNumber),
    //       //     period: data[d].period,
    //       //     payment: parseFloat(data[d].payment),
    //       //     interest: parseFloat(data[d].interest),
    //       //     totalPayment: parseFloat(data[d].totalPayment),
    //       //     totalInterest: parseFloat(data[d].totalInterest),
    //       //     adminFee: parseFloat(data[d].adminFee),
    //       //     serviceCharge: parseFloat(data[d].serviceCharge),
    //       //     creditLifeFee: parseFloat(data[d].creditLifeFee),
    //       //     debitOrder: parseFloat(data[d].debitOrder),
    //       //     creditType: parseInt(data[d].creditType),
    //       //   })
    //       // );

    //       count++;
    //       console.log(count);
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    async addLoanType() {
      try {
        this.creatingLoanType = true;
        // let createdLoanType = {};
        let modelFilteredLoanType = null;
        let newLoanType = null;
        if (this.newModelLoanType.code) {
          modelFilteredLoanType = _.find(this.loanTypes, {
            code: Number(this.newModelLoanType.code),
          });
          if (!modelFilteredLoanType) {
            newLoanType = await DataStore.save(
              new LoanType({
                code: parseInt(this.newModelLoanType.code),
                randValue: parseFloat(this.newModelLoanType.randValue),
                periodNumber: parseInt(this.newModelLoanType.periodNumber),
                period: this.newModelLoanType.period,
                payment: parseFloat(this.newModelLoanType.payment),
                interest: parseFloat(this.newModelLoanType.interest),
                totalPayment: parseFloat(this.newModelLoanType.totalPayment),
                totalInterest: parseFloat(this.newModelLoanType.totalInterest),
                adminFee: parseFloat(this.newModelLoanType.adminFee),
                serviceCharge: parseFloat(this.newModelLoanType.serviceCharge),
                creditLifeFee: parseFloat(this.newModelLoanType.creditLifeFee),
                debitOrder: parseFloat(this.newModelLoanType.debitOrder),
                creditType: parseInt(this.newModelLoanType.creditType),
              })
            );
            this.errorMessage = "";
            this.loanTypes.push(newLoanType);
            this.newModelLoanType = {
              randValue: null,
              periodNumber: null,
              period: null,
              adminFee: null,
              totalInterest: null,
              debitOrder: null,
              creditType: null,
              creditLifeFee: null,
              serviceCharge: null,
              payment: null,
              totalPayment: null,
              code: null,
            };
            this.$refs.form.resetValidation();
          } else {
            this.errorMessage =
              "Loan Type " + modelFilteredLoanType.code + " already exists";
          }
        } else {
          this.errorMessage = "Please enter a code";
        }
        // this.queryLoanTypes();
        this.creatingLoanType = false;
      } catch (error) {
        console.log(error);
      }
    },
    clearLoanType() {
      try {
        this.newModelLoanType = {
          randValue: null,
          periodNumber: null,
          period: null,
          adminFee: null,
          totalInterest: null,
          debitOrder: null,
          creditType: null,
          creditLifeFee: null,
          serviceCharge: null,
          payment: null,
          totalPayment: null,
          code: null,
        };
        this.errorMessage = "";
        this.showAddLoanType = false;
      } catch (error) {
        console.log(error);
      }
    },
    showAddLoanTypeFunction() {
      try {
        this.showAddLoanType = true;
      } catch (error) {
        console.log(error);
      }
    },
    deleteLoanType(item) {
      try {
        DataStore.delete(item);
        this.queryLoanTypes();
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    windowWidth() {
      var size = String;
      if (this.$vuetify.breakpoint) {
        size = this.$vuetify.breakpoint.width;
      }
      return size;
    },
  },
  beforeDestroy() {
    // this.unsubscribeAuth();
    this.subscription.unsubscribe();
  },
};
</script>
<style>
.v-input__slot {
  padding: 0 10px !important;
}
</style>